import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";

const STATUS_OPTIONS = ["pending", "approved", "rejected"];

const formatStatusLabel = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : "";

function MilestoneFilter({ status, setStatus }) {
  return (
    <Grid container justifyContent="flex-end" pb={2}>
      <Grid item xs={12} sm={4} md={3}>
        <Autocomplete
          disablePortal
          id="milestone-filter"
          options={STATUS_OPTIONS}
          value={status || ""}
          sx={{ width: "100%" }}
          getOptionLabel={formatStatusLabel}
          onChange={(_, value) => setStatus(value || "")}
          renderInput={(params) => <TextField {...params} placeholder="Select Filter" />}
          isOptionEqualToValue={(option, value) => option === value}
        />
      </Grid>
    </Grid>
  );
}

MilestoneFilter.propTypes = {
  status: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default MilestoneFilter;
